(() => {
  const storageKey = 'rabbit-boom-wishlist';
  let wishes = new Set();
  try { wishes = new Set(JSON.parse(localStorage.getItem(storageKey) || '[]')); } catch {}
  function refresh() {
    document.querySelectorAll('[data-wishlist]').forEach(b => { const on=wishes.has(b.dataset.wishlist); b.setAttribute('aria-pressed',String(on)); b.textContent=on?'♥':'♡'; b.closest('.product-card')?.classList.toggle('is-wished',on); });
    document.querySelectorAll('.product-grid').forEach(grid => {
      const empty = grid.querySelector('.no-results');
      if(empty) empty.hidden = [...grid.querySelectorAll('.product-card')].some(c => !c.hidden && (!document.body.classList.contains('wishlist-active') || c.classList.contains('is-wished')));
    });
  }
  document.addEventListener('click', e => {
    const wish = e.target.closest('[data-wishlist]');
    if(wish){ const id=wish.dataset.wishlist; wishes.has(id)?wishes.delete(id):wishes.add(id); try{localStorage.setItem(storageKey,JSON.stringify([...wishes]));}catch{} refresh(); }
    const view=e.target.closest('[data-wishlist-view]');
    if(view){const on=document.body.classList.toggle('wishlist-active');view.setAttribute('aria-pressed',String(on));document.querySelector('#new-chaos')?.scrollIntoView();refresh();}
    const concept=e.target.closest('[data-concept]');
    if(concept){e.preventDefault();const card=concept.closest('.product-card'),dialog=document.querySelector('#concept-details');if(!dialog)return;dialog.querySelector('[data-concept-title]').textContent=card.querySelector('h3').textContent;dialog.querySelector('[data-concept-price]').textContent=card.querySelector('.price').textContent;const im=dialog.querySelector('[data-concept-image]');im.src=card.querySelector('.product-picture img').src;im.alt=card.querySelector('h3').textContent;dialog.showModal();}
    if(e.target.closest('.close-dialog,.close-concept'))e.target.closest('dialog').close();
    const nav=e.target.closest('.mobile-menu a');if(nav)nav.closest('details').open=false;
  });
  document.querySelectorAll('dialog').forEach(d=>d.addEventListener('click',e=>{if(e.target===d){const r=d.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)d.close();}}));
  document.addEventListener('shopify:section:load',refresh);
  refresh();
})();


/* Cursor trail: hearts and sparkles, mouse devices only, off under reduced motion. Same behaviour as the live chaos layer. */
(() => {
  if (!matchMedia('(pointer:fine)').matches || matchMedia('(prefers-reduced-motion:reduce)').matches) return;
  const glyphs = ['♥', '✦', '✧', '♡', '★'], colors = ['#FF8CC6', '#C9B8F0', '#14101A', '#FFC2DF'];
  let n = 0, live = 0;
  addEventListener('mousemove', e => {
    if (++n % 3 || live > 28) return;
    const s = document.createElement('span');
    s.className = 'rb-trail'; s.textContent = glyphs[n % glyphs.length];
    s.style.color = colors[(n >> 2) % colors.length];
    s.style.left = (e.clientX + (Math.random() * 10 - 5)) + 'px';
    s.style.top = (e.clientY + (Math.random() * 10 - 5)) + 'px';
    document.body.appendChild(s); live++;
    setTimeout(() => { s.remove(); live--; }, 760);
  }, { passive: true });
})();

/* Product gallery: clicking a thumbnail swaps the main photo. */
document.addEventListener('click', e => {
  const t = e.target.closest('.gallery-thumb'); if (!t) return;
  const main = document.querySelector('#GalleryMain'); if (!main) return;
  main.src = t.dataset.gallerySrc; main.srcset = t.dataset.gallerySrcset;
  t.parentElement.querySelectorAll('.gallery-thumb').forEach(b => { const on = b === t; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', String(on)); });
});


/* Ticker marquee (sections/rb-ticker.liquid): set --ticker-duration from the measured track width so the
   scroll speed stays constant in px/s whatever the text length. Re-measures on resize, font load and in
   the theme editor. Pure CSS fallback (32s) applies if this never runs. */
(() => {
  const size = () => {
    document.querySelectorAll('.ticker[data-ticker-speed]').forEach(ticker => {
      const group = ticker.querySelector('.ticker-group');
      if (!group) return;
      const speed = Number(ticker.dataset.tickerSpeed) || 80;
      const width = group.getBoundingClientRect().width;
      if (width > 0) ticker.style.setProperty('--ticker-duration', (width / speed).toFixed(2) + 's');
    });
  };
  size();
  addEventListener('resize', size, { passive: true });
  document.addEventListener('shopify:section:load', size);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(size);
})();
